import { useTranslation } from "react-i18next";
import Button from "../../../components/Button/Button";
import { useLicenseDetails } from "../../../contexts/licenseDetails";
import Modal from "react-modal";
import { Copy } from "../../../components/Copy/Copy";
import { AnimatedTabbar, AnimatedTabbarItem } from "../../../components/AnimatedTabbar/AnimatedTabbar";
import { LicenseTechnicalStatus } from "../../../components/LicenseTechnicalStatus/LicenseTechnicalStatus";
import { LicenseBillingStatus } from "../../../components/LicenseBillingStatus/LicenseBillingStatus";
import { MdBlock } from "react-icons/md";
import { TbMoneybagPlus } from "react-icons/tb";
import { formatDate } from "../../../utils/date";
import { formatMoney } from "../../../utils/number";
import { BillingPeriodText } from "../../../constants/billing";
import { LuCalendarClock, LuCircleCheck, LuCircleX, LuReplace, LuTrash, LuX } from "react-icons/lu";
import { IoIosPause } from "react-icons/io";
import { formatBytes } from "../../../utils/bytes";
import { BiTransfer } from "react-icons/bi";
import { BsCpu, BsToggles } from "react-icons/bs";
import { TbContract } from "react-icons/tb";
import { LicenseDaysToExpiration } from "../../../components/LicenseDaysToExpiration/LicenseDaysToExpiration";
import { LicenseActionButton } from "../../../components/LicenseActionButton/LicenseActionButton";
import { LicenseBlockPage } from "../../../components/LicenseBlockPage/LicenseBlockPage";
import { LicenseRegisterPaymentPage } from "../../../components/LicenseRegisterPaymentPage/LicenseRegisterPaymentPage";
import { LicenseCreateBillingPage } from "../../../components/LicenseCreateBillingPage/LicenseCreateBillingPage";
import { LicenseUpdateFeaturesPage } from "../../../components/LicenseUpdateFeaturesPage/LicenseUpdateFeaturesPage";
import { LicenseSuspendPage } from "../../../components/LicenseSuspendPage/LicenseSuspendPage";
import { LicenseAllocatePage } from "../../../components/LicenseAllocatePage/LicenseAllocatePage";
import { LicenseUpdateDueDatePage } from "../../../components/LicenseUpdateDueDatePage/LicenseUpdateDueDatePage";
import { LicenseTransferOwnerPage } from "../../../components/LicenseTransferOwnerPage/LicenseTransferOwnerPage";
import { LicenseUpdateSerialNumberPage } from "../../../components/LicenseUpdateSerialNumberPage/LicenseUpdateSerialNumberPage";
import { LicenseDeletePage } from "../../../components/LicenseDeletePage/LicenseDeletePage";
import { EditableText } from "../../../components/EditableText/EditableText";
import LicenseService from "../../../services/LicensesService";
import { LicenseBillingPage } from "../../../components/LicenseBillingPage/LicenseBillingPage";
import { useEffect } from "react";
import { LicenseUnblockPage } from "../../../components/LicenseUnblockPage/LicenseUnblockPage";
import { LicenseSchedulingPage } from "../../../components/LicenseSchedulingPage/LicenseSchedulingPage";
import { LicenseHistoricPage } from "../../../components/LicenseHistoricPage/LicenseHistoricPage";

export function LicenseDetails({ ...props }) {
   const { t } = useTranslation();
   const {
      license,
      setLicense,
      showModal,
      setShowModal,
      currentTab,
      setCurrentTab,
      currentSubTab,
      setCurrentSubTab,
      isLoading,
      closeModal,
   } = useLicenseDetails();

   async function handleConfirm() { }

   async function handleCancel() {
      closeModal();
   }

   async function saveRenameLicense(tag) {
      const response = await LicenseService.renameLicense(license.id, tag);
   }

   useEffect(() => {
      function onKeyPress(e) {
         if (e.key === "Escape") {
            closeModal();
         }
      }
      window.addEventListener('keyup', onKeyPress);
      return () => window.removeEventListener('keyup', onKeyPress);
   });

   return (
      <div>
         <Modal
            closeTimeoutMS={100}
            isOpen={showModal}
            // onAfterOpen={afterOpenModal}
            onRequestClose={handleCancel}
            style={{
               content: {
                  width: `min(1100px, 95dvw)`,
                  top: "50%",
                  left: "50%",
                  right: "auto",
                  bottom: "auto",
                  marginRight: "-50%",
                  transform: "translate(-50%, -50%)",
                  border: "1px solid var(--borderColor)",
                  backgroundColor: "var(--containerBackgroundColor)",
                  borderRadius: "10px",
               },
            }}
            contentLabel="Modal"
            ariaHideApp={false}
         >
            <div className="modal-content-container p-4!">
               <div className="w-full flex flex-col gap-4!">
                  <div className="w-full flex flex-row justify-between">
                     <div className="flex flex-row items-center">
                        {props.icon}
                        <h1 className="modal-text m-0!">
                           <EditableText
                              className="font-bold! text-[18px]!"
                              value={license?.tag}
                              onConfirm={async (newValue) => {
                                 await saveRenameLicense(newValue);
                              }}
                              onComplete={(newValue) => {
                                 setLicense({
                                    ...license,
                                    tag: newValue,
                                 })
                              }}
                           />
                        </h1>
                        <span className="inline-flex ml-5! opacity-60 text-xs!">{license?.type?.name}</span>
                     </div>
                     <div className="flex flex-row items-center gap-3!">
                        <LicenseTechnicalStatus license={license} withBackground={false} />
                        <LicenseBillingStatus license={license} descriptive={true} />
                        <button
                           type="button"
                           className="size-8 hover:bg-(--borderColor)! duration-150 cursor-pointer rounded-(--borderRadius)!"
                           onClick={e => closeModal()}
                        >
                           <LuX size={19} />
                        </button>
                     </div>
                  </div>
                  <div className="flex flex-row items-center gap-1.5 opacity-60">
                     <span>Código:{' '}</span>
                     <Copy text={license?.externalId} />
                  </div>
                  <div className="flex flex-row items-center gap-1.5">
                     <span className="opacity-60">Tag:{' '}</span>
                     <span className="text-(--primaryColor)">{license?.tag}</span>
                  </div>
                  <div className="flex flex-row items-center gap-3 mt-3!">
                     <Button
                        className={"button-blue"}
                        disabled={isLoading}
                        icon={<TbMoneybagPlus size={19} />}
                        label={"Registrar pagamento"}
                        type={"submit"}
                        onClick={() => {
                           setCurrentTab("billing");
                           setCurrentSubTab("register-payment");
                        }}
                     />
                     {license?.technicalStatus === 'BLOCKED' ? (
                        <Button
                           className={"button-white"}
                           icon={<MdBlock size={19} />}
                           label={"Desbloquear"}
                           onClick={() => {
                              setCurrentTab("actions");
                              setCurrentSubTab("unblock");
                           }}
                        />
                     ) : (
                        <Button
                           className={"button-white"}
                           icon={<MdBlock size={19} />}
                           label={"Bloquear"}
                           onClick={() => {
                              setCurrentTab("actions");
                              setCurrentSubTab("block");
                           }}
                        />
                     )}
                     {license?.automaticRenew && (
                        <Button
                           className={"button-white"}
                           icon={<IoIosPause size={19} />}
                           label={"Suspender"}
                           onClick={() => {
                              setCurrentTab("actions");
                              setCurrentSubTab("suspend");
                           }}
                        />
                     )}
                  </div>
                  <div className="border-b! border-(--borderColor)!">
                     <AnimatedTabbar
                        value={currentTab}
                        className={`border-none!`}
                        onChange={value => {
                           setCurrentTab(value);
                           setCurrentSubTab(null);
                        }}
                     >
                        <AnimatedTabbarItem name="overview">
                           <span>Visão geral</span>
                        </AnimatedTabbarItem>
                        <AnimatedTabbarItem name="hierarchy">
                           <span>Hierarquia</span>
                        </AnimatedTabbarItem>
                        <AnimatedTabbarItem name="billing">
                           <span>Financeiro</span>
                        </AnimatedTabbarItem>
                        <AnimatedTabbarItem name="scheduling">
                           <span>Agendamentos</span>
                        </AnimatedTabbarItem>
                        <AnimatedTabbarItem name="historic">
                           <span>Histórico</span>
                        </AnimatedTabbarItem>
                        <AnimatedTabbarItem name="actions">
                           <span>Ações</span>
                        </AnimatedTabbarItem>
                     </AnimatedTabbar>
                  </div>
                  <div className="mt-1.5!">
                     {currentTab === 'overview' && (
                        <div className="flex flex-col gap-4! fade-in">
                           <div className="p-5! border! border-(--borderColor)! rounded-(--borderRadius)!">
                              <h3 className="font-bold! mb-5!">Informações da licença</h3>
                              <div className="grid grid-cols-2 gap-x-12! gap-y-4!">
                                 <div className="flex flex-row items-center justify-between">
                                    <span className="opacity-60">Criada em</span>
                                    <span>{formatDate(license?.createdAt)}</span>
                                 </div>
                                 <div className="flex flex-row items-center justify-between">
                                    <span className="opacity-60">Valor {BillingPeriodText[license?.currentBilling?.period]}</span>
                                    <span>R$ {formatMoney(license?.currentBilling?.finalAmount)}</span>
                                 </div>
                                 <div className="flex flex-row items-center justify-between">
                                    <span className="opacity-60">Expiração atual</span>
                                    <span>{formatDate(license?.currentBilling?.dueDate)}</span>
                                 </div>
                                 <div className="flex flex-row items-center justify-between">
                                    <span className="opacity-60">Cobrança</span>
                                    <span>{BillingPeriodText[license?.currentBilling?.period]}</span>
                                 </div>
                                 <div className="flex flex-row items-center justify-between">
                                    <span className="opacity-60">Próxima cobrança</span>
                                    {license?.nextDueDate ? (
                                       <span>{formatDate(license?.nextDueDate)}</span>
                                    ) : (
                                       <span className="opacity-50">Não consta</span>
                                    )}
                                 </div>
                                 <div className="flex flex-row items-center justify-between">
                                    <span className="opacity-60">Renovação automática</span>
                                    <span className="inline-flex flex-row items-center gap-1">
                                       {license?.automaticRenew ? (
                                          <>
                                             <LuCircleCheck />
                                             Ativada
                                          </>
                                       ) : (
                                          <>
                                             <LuCircleX />
                                             Inativada
                                          </>
                                       )}
                                    </span>
                                 </div>
                              </div>
                           </div>
                           <div className="p-5! border! border-(--borderColor)! rounded-(--borderRadius)!">
                              <h3 className="font-bold! mb-5!">Situação atual</h3>
                              <div className="grid grid-cols-3 gap-x-12! gap-y-4!">
                                 <div className="flex flex-col justify-between gap-2!">
                                    <span className="opacity-60">Status técnico</span>
                                    <span>
                                       <LicenseTechnicalStatus className="p-0! text-[15px]!" license={license} withBackground={false} />
                                    </span>
                                 </div>
                                 <div className="flex flex-col justify-between gap-2!">
                                    <span className="opacity-60">Status financeiro</span>
                                    <span>
                                       <LicenseBillingStatus className="p-0! text-[15px]!" license={license} withBackground={false} />
                                    </span>
                                 </div>
                                 <div className="flex flex-col justify-between gap-3.5!">
                                    <span className="opacity-60">Dias até vencimento</span>
                                    <LicenseDaysToExpiration license={license} />
                                 </div>
                              </div>
                           </div>
                           <div className="p-5! border! border-(--borderColor)! rounded-(--borderRadius)!">
                              <h3 className="font-bold! mb-5!">Dispositivo e local associado</h3>
                              <div className="grid grid-cols-2 gap-x-12! gap-y-4!">
                                 <div className="flex flex-row items-center justify-between">
                                    <span className="opacity-60">Unidade</span>
                                    {license?.allocatedUnit ? (
                                       <span>{license.allocatedUnit.name}</span>
                                    ) : (
                                       <span className="opacity-50">Não alocado</span>
                                    )}
                                 </div>
                                 <div className="flex flex-row items-center justify-between">
                                    <span className="opacity-60">Local</span>
                                    {license?.allocatedUnit ? (
                                       <>
                                          {license.allocatedUnit.address ? (
                                             <span>{license.allocatedUnit.address.city} - {license.allocatedUnit.address.state}</span>
                                          ) : (
                                             <span className="opacity-50">Não consta</span>
                                          )}
                                       </>
                                    ) : (
                                       <span className="opacity-50">Não alocado</span>
                                    )}
                                 </div>
                                 <div className="flex flex-row items-center justify-between">
                                    <span className="opacity-60">Modelo</span>
                                    <span>{license?.type?.name}</span>
                                 </div>
                                 <div className="flex flex-row items-center justify-between">
                                    <span className="opacity-60">Número de série</span>
                                    {license?.serialNumber ? (
                                       <span>{license.serialNumber}</span>
                                    ) : (
                                       <span className="opacity-50">Não associado</span>
                                    )}
                                 </div>
                                 <div className="flex flex-row items-center justify-between">
                                    <span className="opacity-60">Associado em</span>
                                    {license?.serialNumber ? (
                                       <>
                                          {license.lastCompletedAssociation ? (
                                             <span>{formatDate(license.lastCompletedAssociation.createdAt, true)}</span>
                                          ) : (
                                             <span className="opacity-50">Não consta</span>
                                          )}
                                       </>
                                    ) : (
                                       <span className="opacity-50">Não associado</span>
                                    )}
                                 </div>
                              </div>
                           </div>
                           <div className="p-5! border! border-(--borderColor)! rounded-(--borderRadius)!">
                              <h3 className="font-bold! mb-5!">Recursos e funcionalidades</h3>
                              {license?.features?.length > 0 ? (
                                 <div className="flex flex-wrap gap-2!">
                                    {license.features.map(feature => (
                                       <span className="inline-flex items-center px-4! py-2! border! border-(--borderColor)! rounded-full!">
                                          {feature.name}
                                          {feature.code === 'F-B' && license.metadata?.backupSize && (
                                             <span className="inline-flex text-xs! opacity-60 ml-1.5!">{formatBytes(Number(license.metadata.backupSize))}</span>
                                          )}
                                       </span>
                                    ))}
                                 </div>
                              ) : (
                                 <div className="flex flex-wrap gap-2!">
                                    <span className="opacity-50">Nenhum</span>
                                 </div>
                              )}
                           </div>
                           <div className="p-5! border! border-(--borderColor)! rounded-(--borderRadius)!">
                              <h3 className="font-bold! mb-5!">Proprietário atual</h3>
                              <div className="flex flex-wrap gap-2!">
                                 <span className="opacity-50">Em breve</span>
                              </div>
                           </div>
                           <div className="p-5! border! border-(--borderColor)! rounded-(--borderRadius)!">
                              <h3 className="font-bold! mb-5!">Resumo financeiro</h3>
                              <div className="flex flex-wrap gap-2!">
                                 <span className="opacity-50">Em breve</span>
                              </div>
                           </div>
                        </div>
                     )}

                     {currentTab === 'hierarchy' && (
                        <div className="fade-in">
                           <h2 className="text-lg! opacity-50">Em breve</h2>
                        </div>
                     )}

                     {currentTab === 'billing' && !currentSubTab && <LicenseBillingPage license={license} />}

                     {currentTab === 'historic' && <LicenseHistoricPage license={license} />}

                     {currentTab === 'scheduling' && <LicenseSchedulingPage license={license} />}

                     {currentTab === 'actions' && !currentSubTab && (
                        <div className="grid grid-cols-4 gap-3! fade-in">
                           <LicenseActionButton
                              onClick={() => {
                                 setCurrentTab("billing");
                                 setCurrentSubTab('register-payment');
                              }}
                           >
                              <TbMoneybagPlus size={22} />
                              Registrar pagamento
                           </LicenseActionButton>

                           <LicenseActionButton
                              onClick={() => {
                                 setCurrentTab('billing');
                                 setCurrentSubTab('create-billing');
                              }}
                           >
                              <TbContract size={22} />
                              Nova cobrança
                           </LicenseActionButton>

                           <LicenseActionButton
                              onClick={() => setCurrentSubTab('update-features')}
                           >
                              <BsToggles size={22} />
                              Ajustar recursos
                           </LicenseActionButton>

                           {license?.technicalStatus === 'BLOCKED' ? (
                              <LicenseActionButton
                                 onClick={() => setCurrentSubTab('unblock')}
                              >
                                 <MdBlock size={22} />
                                 Desbloquear
                              </LicenseActionButton>
                           ) : (
                              <LicenseActionButton
                                 onClick={() => setCurrentSubTab('block')}
                              >
                                 <MdBlock size={22} />
                                 Bloquear
                              </LicenseActionButton>
                           )}

                           <LicenseActionButton
                              onClick={() => setCurrentSubTab('suspend')}
                           >
                              <IoIosPause size={22} />
                              Suspender
                           </LicenseActionButton>

                           <LicenseActionButton
                              onClick={() => setCurrentSubTab('transfer-owner')}
                           >
                              <BiTransfer size={22} />
                              Transferir propriedade
                           </LicenseActionButton>

                           <LicenseActionButton
                              onClick={() => setCurrentSubTab('allocate')}
                           >
                              <LuReplace size={22} />
                              (Re)Alocar
                           </LicenseActionButton>

                           <LicenseActionButton
                              onClick={() => setCurrentSubTab('update-serial-number')}
                           >
                              <BsCpu size={22} />
                              Alterar número de série
                           </LicenseActionButton>

                           <LicenseActionButton
                              onClick={() => setCurrentSubTab('update-due-date')}
                           >
                              <LuCalendarClock size={22} />
                              Alterar vencimento
                           </LicenseActionButton>

                           <LicenseActionButton
                              className="border-red-400! text-red-400! hover:bg-red-400/5! duration-200"
                              onClick={() => setCurrentSubTab('delete')}
                           >
                              <LuTrash size={22} />
                              Deletar
                           </LicenseActionButton>
                        </div>
                     )}

                     {currentTab === 'billing' && currentSubTab === 'register-payment' && (
                        <LicenseRegisterPaymentPage license={license} />
                     )}

                     {currentTab === 'billing' && currentSubTab === 'create-billing' && (
                        <LicenseCreateBillingPage license={license} />
                     )}

                     {currentTab === 'actions' && currentSubTab === 'update-features' && (
                        <LicenseUpdateFeaturesPage license={license} />
                     )}

                     {currentTab === 'actions' && currentSubTab === 'block' && (
                        <LicenseBlockPage license={license} />
                     )}

                     {currentTab === 'actions' && currentSubTab === 'unblock' && (
                        <LicenseUnblockPage license={license} />
                     )}

                     {currentTab === 'actions' && currentSubTab === 'suspend' && (
                        <LicenseSuspendPage license={license} />
                     )}

                     {currentTab === 'actions' && currentSubTab === 'allocate' && (
                        <LicenseAllocatePage license={license} />
                     )}

                     {currentTab === 'actions' && currentSubTab === 'update-due-date' && (
                        <LicenseUpdateDueDatePage license={license} />
                     )}

                     {currentTab === 'actions' && currentSubTab === 'transfer-owner' && (
                        <LicenseTransferOwnerPage license={license} />
                     )}

                     {currentTab === 'actions' && currentSubTab === 'update-serial-number' && (
                        <LicenseUpdateSerialNumberPage license={license} />
                     )}

                     {currentTab === 'actions' && currentSubTab === 'delete' && (
                        <LicenseDeletePage license={license} />
                     )}
                  </div>
               </div>

               <div>

               </div>
            </div>
         </Modal >
      </div >
   );
}